<template>
  <div class="content">
    <h1 class="has-text-centered">
      AHL Jobs
    </h1>
    <hr>
    <div class="columns">
      <div class="column is-8">
        <jobs-list
          v-if="page === 'job-list'"
          :jobs="jobs"
          class="box box-jobs"
          @selectJob="showJobDescription"
        />
        <job-page
          v-if="page === 'job-page'"
          :job="selectedJob"
          @showList="showList"
        />
      </div>
      <div class="column is-4">
        <h5 class="subtitle is-5">
          AHL Employment Opportunities
        </h5>
        <div
          v-if="contact"
          class="box box-information"
        >
          <strong>{{ contact['contact_name'] }}</strong>
          <br>
          <p v-for="email in contact['contact_email'].split(';')">
            <a class="link"><i class="far fa-envelope-open-o" /> {{ email }}</a>
          </p>
          <p><strong><i class="far fa-mobile-phone" /> {{ contact['contact_phone'] }}</strong></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import JobsList from './JobsList.vue'
  import JobPage from './JobPage.vue'
  export default {
    name: 'Jobs',
    metaInfo: {
      title: 'AHL Poker :: Jobs'
    },
    components: {
      JobsList,
      JobPage
    },
    data () {
      return {
        page: 'job-list',
        contact: '',
        jobs: [
          {
            title: 'Tournament Director',
            short: 'If you are looking for a fun, exciting, easy way to make some extra money.',
            description: '<p>If you are looking for a fun, exciting, easy way to make some extra money, the AHL host program offers just what you\'re looking for.</p>',
            offers: [
              'Flexible hours',
              'Evening hours',
              'Fun, Social enviroment',
              'Nightly pay'
            ],
            requirements: [
              'Know how to play Texas Hold\'em',
              'Be an AHL Poker member',
              'Be willing to talk to others and have fun at work'
            ],
            conclusion: '<p class="text-center">If this sounds like you please click the button below to apply: </p>' +
            '<a href="/contact/employment" style="width: 300px" class="button is-info">Apply Now</a>'
          }
        ],
        selectedJob: ''
      }
    },
    methods: {
      showJobDescription (job) {
        this.selectedJob = job
        this.page = 'job-page'
      },
      showList () {
        this.selectedJob = ''
        this.page = 'job-list'
      }
    }
  }
</script>
